import React, { useMemo } from "react";
import FullWidthModal from "../../components/common/Modal/FullWidthModal";
import cn from "classnames";
import ModalHeader from "../../components/common/ModalHeader/index";
import {
  TouchableButton,
  TouchableDiv,
} from "../../components/common/Touchable/index";
import styles from "./viewreceipt.module.scss";
import { LABEL } from "../../veriables";
import { APP_CONFIG } from '@constants';
import { useNavigate  } from 'react-router-dom';
import { connect } from "react-redux";
import { FormatLoyaltyPhoneNumber } from '@utility/helperFunction';

const LoyaltyListPopUp = (props) => {
  const {
    openLoyalty,
    setOpenLoyalty,
    serverAppTheme,
    seat,
    loyaltyList,
    setSelectedLoyalty,
    handleLoyaltySubmit,
    selectedLoyalty,
    count,
    orderingPortraitOrientation
  } = props;

  const navigate = useNavigate();
  const popUpModal = useMemo(() => {
    const okButton = {
      backgroundColor: serverAppTheme?.secondaryBtn,
      color: "#ffff",
      border: "none",
      borderRadius: "8px",
    };

    return { okButton };
  }, [serverAppTheme]);

  return (
    <FullWidthModal
      isOpen={openLoyalty}
      customClass2={cn("w-100 h-100 position-relative")}
      style={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: "100%",
        pointerEvents: "auto",
        backgroundColor: serverAppTheme?.popUp_bg,
        backgroundClip: "padding-box",
        border: "0",
        boxShadow: serverAppTheme?.popUp_box_shadow,
      }}
    >
      <div
        className="col-12 px-0 justify-content-center align-items-center position-relative text-center h-100"
        style={popUpModal.primaryTextColor}
      >
        <div
          className={cn(
            "col-12 px-0 fs_18 align-items-center justify-content-center fw-600 h-100",
          )}
        >
          <ModalHeader
            stationName={seat?.stationName}
            tileHeader={
              props.isSplitEvenly
                ? LABEL().SE_SELECT_LOYALTY_ACCOUNT_HEADER
                : LABEL().PF_SELECT_LOYALTY_ACCOUNT_HEADER
            }
            seatNumber={seat?.number}
          />
          <div className="fs_18 fw-600 text-center py-3">
            {props.isSplitEvenly
              ? LABEL().SE_SELECT_LOYALTY_ACCOUNT
              : LABEL().PF_SELECT_LOYALTY_ACCOUNT}
            {props.isSplitEvenly && (
              <div className="fs_14 fw-500 text-center py-2">
                {props.isSplitEvenly
                  ? LABEL().SE_ACCOUNT_SELECT
                  : LABEL().PF_ACCOUNT_SELECT}{" "}
                : {count}
              </div>
            )}
          </div>
          <div
            className={cn(
              "col-12 px-0 large-input m-auto justify-content-center  position-relative h-90",
            )}
          >
            <div
              className={cn(
                "col-12 w-100 overflowY",
                props.isSplitEvenly ? (orderingPortraitOrientation ? 'h-84 px-0' : "h-70 px-3") : (orderingPortraitOrientation ? 'h-88 px-0' : "h-76 px-3"),
              )}
            >
              <div
                className={cn(
                  "col-12 d-flex p-0 mx-0 flex-wrap justify-content-center w-100",
                  styles.wrapper,
                )}
              >
                {/* split evenly && payfullcheck loyalty modal */}
                {loyaltyList.length > 0 &&
                  loyaltyList.map((item, index) => {
                    const isSelected = props.isSplitEvenly
                      ? selectedLoyalty.includes(item?.id)
                      : selectedLoyalty?.id === item?.id;
                    return (
                      <TouchableDiv
                        key={index}
                        className="d-flex align-items-center justify-content-center flex-column p-2 mx-2 mb-2"
                        style={{
                          width: orderingPortraitOrientation ? '46%' : "22%",
                          minWidth: "120px",
                          borderRadius: "4px",
                          backgroundColor: isSelected
                            ? serverAppTheme.selected
                            : serverAppTheme.unselected,
                            height: orderingPortraitOrientation ? '80px' : ''
                        }}
                        role="presentation"
                        onClick={() => {
                          props.isSplitEvenly
                            ? props.addToSplitEvenlyArr(item)
                            : setSelectedLoyalty(item);
                        }}
                      >
                        <div
                          className="fw-600 fs_16"
                          style={{ height: "24px" }}
                        >
                          {item?.guestName || ""}
                        </div>
                        <div
                          className={cn(orderingPortraitOrientation ? 'fs_20 fw-600' : 'fs_16 fs-400')}
                          style={{ height: "24px" }}
                        >
                          {item?.displayAccountNumber
                            ? FormatLoyaltyPhoneNumber(item.displayAccountNumber)
                            : ""}
                        </div>
                      </TouchableDiv>
                    );
                  })}
              </div>
            </div>
            <div className={cn("d-flex col-12 justify-content-center", orderingPortraitOrientation ? 'pb-3' : '')}>
              <div className={cn(orderingPortraitOrientation ? 'col-6 pl-0 pr-1' : 'col-5 pr-1')}>
                <TouchableButton
                  type="button"
                  className={cn(
                    "pr-0 pl-2  rounded btn-ripple fw-600 w-100", orderingPortraitOrientation ? 'btn68' : 'btn44 mt-2 mb-2'
                  )}
                  onClick={(e) => {
                    e.preventDefault();
                    setOpenLoyalty(false);
                    props.isSplitEvenly
                      ? setSelectedLoyalty([])
                      : setSelectedLoyalty(null);
                  }}
                  style={{
                    backgroundColor: serverAppTheme?.OFF_Premise_Btn,
                    border: serverAppTheme?.cancleBtn_Border,
                    color: serverAppTheme?.cancleBtn_font,
                  }}
                  rippleEffect={true}
                >
                  {props.isSplitEvenly ? LABEL().SE_CANCEL : LABEL().PF_CANCEL}
                </TouchableButton>
              </div>
              <div className={cn(orderingPortraitOrientation ? 'col-6 pl-1 pr-0' : 'col-5 pl-1 pr-0')}>
                <TouchableButton
                  className={cn("w-100  btn-ripple", orderingPortraitOrientation ? 'btn68' : 'btn44 mt-2')}
                  type="button"
                  onClick={(e) => {
                    e.preventDefault();
                    if (props.isSplitEvenly && !props.fromPay) {
                        navigate(`${APP_CONFIG.BASE_URL}/serverApp/checks`, { replace: true });

                    } else {
                      handleLoyaltySubmit();
                    }
                  }}
                  style={popUpModal.okButton}
                  rippleEffect={true}
                >
                  <div className={("fw-600", orderingPortraitOrientation ? 'fs_28' : 'fs_24')}>
                    {props.isSplitEvenly ? LABEL().SE_OK : LABEL().PF_OK}
                  </div>
                </TouchableButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </FullWidthModal>
  );
};
const mapStateToProps = ({ orders }) => ({
  orderingPortraitOrientation: orders.orderingPortraitOrientation
});

export default connect(mapStateToProps) (LoyaltyListPopUp);
